





































































import Vue from 'vue'
import { Component, Config } from '@niknevis/vue-modules'
import { ModelSync, Prop } from 'vue-property-decorator'
import ContentItemStatusView from '@/modules/content-item/components/shared/ContentItemStatusView.vue'

@Component({
  components: { ContentItemStatusView }
})
export default class ContentEditorUploader extends Vue {
  @ModelSync('value', 'input') file!: File
  @Prop({ default: false }) loading!: boolean

  userType = Config.get('userType')

}
